import type React from "react"
import { ColorPanelRoot } from "./color-panel"
import type { ColorPanelProps } from "./color-panel"
import { ColorPanelHex } from "./color-panel-hex"
import { ColorPanelPicker } from "./color-panel-picker"
import { ColorPanelSavedColors } from "./color-panel-saved-colors"
import { ColorPanelDesignColors } from "./color-panel-design-colors"

export { ColorInput } from "./color-input"
export type { ColorInputProps } from "./color-input"
export type { ColorPanelProps } from "./color-panel"
export type { ColorPanelPickerProps } from "./color-panel-picker"
export type { ColorPanelSavedColorsProps } from "./color-panel-saved-colors"
export type { ColorPanelDesignColorsProps } from "./color-panel-design-colors"
export { SavedColorsProvider } from "./saved-colors-provider"
export type { SavedColorsProviderProps } from "./saved-colors-provider"
export { DesignColorsProvider } from "./design-colors-provider"
export type { DesignColorsProviderProps } from "./design-colors-provider"
export type { SavedColors } from "./saved-colors-section"
export type { DesignColors } from "./design-colors-section"
export { getColorInHex } from "./get-color-in-hex"

interface ColorPanelComponent {
  (props: ColorPanelProps): React.JSX.Element
  Hex: typeof ColorPanelHex
  Picker: typeof ColorPanelPicker
  SavedColors: typeof ColorPanelSavedColors
  DesignColors: typeof ColorPanelDesignColors
}

export const ColorPanel: ColorPanelComponent = Object.assign(ColorPanelRoot, {
  Hex: ColorPanelHex,
  Picker: ColorPanelPicker,
  SavedColors: ColorPanelSavedColors,
  DesignColors: ColorPanelDesignColors
} as const)
